import React, { useEffect, useState } from 'react';

import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';
import { getTransactionContactBillingInfo } from '@components/Project/ProjectTransactions/Transactions/TransactionCreateFormUtils';

//import { Segmented } from 'antd';
import { TransactionDrawerContent } from '../../Project/ProjectTransactions/Transactions/ProjectTransactionsUI';
import CommAsMothAgForm from '../TransactionsCreateForms/CommAsMothAgForm';

const AddExternalJobTransactionDrawer = ({ event, onClose, clientBillingInfos }) => {
    const drawerWidth = '40vw';
    const drawerMinWidth = '640px';
    const [touchForm, setTouchForm] = useState(false);
    //const [selectedTab, setSelectedTab] = useState(1);

    return (
        <NwDrawer
            title="Add External Job Transaction"
            onClose={onClose}
            visible={true}
            width={drawerWidth}
            minWidth={drawerMinWidth}
            touchForm={touchForm}
            onTouchForm={setTouchForm}
        >
            {!event ? (
                <Loading />
            ) : (
                <TransactionDrawerContent>
                    <CommAsMothAgForm
                        externalJobData={event}
                        onCloseDrawer={onClose}
                        clientBillingInfos={clientBillingInfos}
                        width={drawerWidth}
                        minWidth={drawerMinWidth}
                    />
                    {/* <Segmented
                        block
                        value={selectedTab}
                        onChange={setSelectedTab}
                        options={[
                            {
                                label: (
                                    <div>
                                        <h2>Commission as mother agency</h2>
                                        <small></small>
                                    </div>
                                ),
                                value: 1,
                            },
                            {
                                label: (
                                    <div>
                                        <h2>Other</h2>
                                        <small>???</small>
                                    </div>
                                ),
                                value: 2,
                            }
                        ]}
                    />
                    {selectedTab === 1 &&
                        <CommAsMothAgForm
                            externalJobData={event}
                            onCloseDrawer={onClose}
                            clientBillingInfos={clientBillingInfos}
                        />
                    }
                    {selectedTab === 2 &&
                        <p></p>
                    } */}
                </TransactionDrawerContent>
            )}
        </NwDrawer>
    );
};

export default AddExternalJobTransactionDrawer;
